import { MouseEvent, memo } from 'react';
import Button from './Button.component';
import { Container } from '../container/Container';
import GridComponent from "../grid/GridComponent.component";
import ButtonLink from './ButtonLink.component';
import { ButtonInterface } from './interface/Button';
import { Grid } from '@material-ui/core';
import { IoMdCheckboxOutline } from 'react-icons/io';
import { RequiredFields } from './ButtonStyle';
import { Span } from '../mandatoryFieldSignaling/MandatoryFieldSignaling';

interface PropsLink extends ButtonInterface {
    link: string;
    onClick?(event: MouseEvent<HTMLElement>): void;
}

function ButtonForm({ ...props }: PropsLink) {
    const { link, onClick } = props;

    return (
        <Grid item xs={12}>
            <Container margin="10px 0px">
                <RequiredFields>Campos obrigatórios <Span>*</Span></RequiredFields>
                <GridComponent >
                    {!onClick && <Button {...props} size='medium' margin="0px 15px 0px 0px" icon={<IoMdCheckboxOutline color='#FFF' size={25} />} />}
                    {onClick && (
                        <Button type="button" size='medium' margin="0px 15px 0px 0px" {...props} />
                    )}

                    <ButtonLink link={link || '/'} size='medium' title='Voltar' variant='outlined' />
                </GridComponent>
            </Container>
        </Grid>
    );
}

export default memo(ButtonForm);